




















































import { Vue, Component, Prop, Watch } from 'vue-property-decorator'
import { debounce } from 'quasar'
import PersonAvatar from 'components/account/PersonAvatar.vue'
import api from 'src/assets/api/gql'
import PersonSearch from 'src/graphql/person/PersonSearch.gql'
import { PersonPublicProfile } from 'src/graphql/types'

@Component({
  components: {
    PersonAvatar
  }
})
export default class ItemPersonSearch extends Vue {
  loading = false
  query = ''
  found: PersonPublicProfile[] = []

  @Prop({ default: true })
  readonly autofocus!: boolean

  created () {
    this.searchPerson = debounce(this.searchPerson, 700)
  }

  @Watch('query')
  search (query: string) {
    this.found = []
    if (query.length < 2) {
      this.loading = false
    } else {
      this.loading = true
      this.searchPerson(query)
    }
  }

  async searchPerson (query: string) {
    const { data: { personSearch } } = await api.query({
      query: PersonSearch,
      variables: { search: query }
    })
    if (query === this.query && personSearch) {
      this.found = personSearch.nodes as PersonPublicProfile[]
    }
    this.loading = false
  }
}
